// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

const AkGrid = (num: number = 1) => ({
	px: `${num * 8}px`,
	unitless: num * 8,
	multiple: (multiplier: number) => AkGrid(multiplier * num),
	half: () => AkGrid(0.5 * num),
	twice: () => AkGrid(2 * num),
});

export const zIndex: {
	searchDialog: 300;
} = {
	searchDialog: layers.dialog(),
};

export const grid: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = AkGrid(1);

export const atlassianNavigationHeight = '56px';

export const collapsedSearchInputWidth = '200px';
export const filterLabelWidth = '150px';

export const dialogWidth = '780px';
export const dialogPageTakeoverWidth: number = 780;
export const dialogPageCentreWidth = '1130px';

export const inputFieldHeight: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = grid.multiple(4);
export const enlargedInputFieldHeight: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = grid.multiple(6);

export const primaryTextColour: 'var(--ds-text)' = token('color.text');
export const itemLinkSecondaryColor: 'var(--ds-text-subtlest)' = token('color.text.subtlest');
export const itemHighlightColor: 'var(--ds-background-neutral-subtle-hovered)' = token(
	'color.background.neutral.subtle.hovered',
);
export const visitedLinkColor: 'var(--ds-link-visited)' = token('color.link.visited');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const nowrapEllipsis: import('@emotion/utils').SerializedStyles = css({
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
});
